import { render, staticRenderFns } from "./partsadd.vue?vue&type=template&id=0e6508a2"
import script from "./partsadd.vue?vue&type=script&lang=js"
export * from "./partsadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports